import React, {useCallback, useState} from 'react';
import {Button, Col, Row} from 'reactstrap';

import Modal from 'components/Modal';
import useExitIntent from 'utils/useExitIntent.js';

export default function ModalExitLanding({children, ...props}) {
  const {isOpen, toggle} = useExitIntent(30000);
  return (
    <Modal className="modal-exit-intent modal-exit-intent-landing" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center text-lg-left d-flex align-items-stretch m-0">
        <Col xs="12" lg="7" className="modal-exit-intent-copy order-lg-2 my-auto">
          <h4 className="section-heading mb-4">
            You deserve the truth <br className="d-none d-sm-block" />
            about your brain.
          </h4>
          <p className="mb-0">
            Do you want to know what the LATEST <br className="d-none d-sm-block d-lg-none" />
            neuroscience says about how to keep your <br className="d-none d-sm-block d-lg-none" />
            brain HEALTHY <br className="d-none d-lg-block d-xl-none" />
            for your entire life?
          </p>
          <Button className="btn-exit text-uppercase text-white text-h5" color="cta" onClick={toggle} block>
            Join the Masterclass NOW
          </Button>
        </Col>
        <Col xs="12" lg="5" className="exit-modal-image-col order-lg-1">
          <div className="exit-modal-image background-image-woman-confident" />
        </Col>
      </Row>
    </Modal>
  );
}
